<script>
import axios from 'axios';
import Markdown from '@/components/Markdown.vue';
import RequestOrderConfirmation from '@/components/forms/RequestOrderConfirmation.vue';
import PageContainer from '@/components/PageContainer.vue';

export default {
    components: {
        PageContainer,
        RequestOrderConfirmation,
        Markdown,
    },
    async asyncData({ route }) {
        try {
            const client = axios.create();
            const response = await client.get('https://content.bubblegumballoons.com/items/help_page', {
                params: {
                    fields: [
                        'top_content',
                        'bottom_content',
                    ],
                },
            });

            return {
                page: response.data?.data,
            };
        } catch (e) {
            return { page: {} };
        }
    },
    computed: {
        categories() {
            return this.$store.getters['help/categories'];
        },
        activeCategorySlug() {
            if (this.$store.getters['help/activeCategory']) {
                return this.$store.getters['help/activeCategory'].slug;
            }

            return null;
        },
    },
    mounted() {
        this.$store.dispatch('help/fetchCategories');
    },
};
</script>

<template>
    <PageContainer>
        <markdown
            v-if="page.top_content"
            :markdown="page.top_content"
            class="mb-8 text-center"
        />
        <nav class="md:flex justify-between flex-wrap md:flex-nowrap space-y-2 md:space-y-0">
            <nuxt-link
                v-for="category in categories"
                :key="category.id"
                :to="`/help/${category.slug}`"
                class="px-8 py-4 flex items-center gap-4 rounded-full"
                :class="activeCategorySlug === category.slug ? 'bg-green-lightest' : 'bg-blue-100'"
            >
                <img
                    v-if="category.image"
                    :src="category.image.url"
                    :alt="category.image.alt"
                    :width="category.image.width"
                    :height="category.image.height"
                    class="h-8 w-auto"
                >
                <span class="font-bold text-md">
                    {{ category.name }}
                </span>
            </nuxt-link>
        </nav>
        <div>
            <NuxtChild :key="$route.params.category" />
        </div>
        <div class="border-t-2 border-blue-100 my-8" />
        <markdown
            v-if="page.bottom_content"
            :markdown="page.bottom_content"
            class="my-8 text-center center-images"
        />
        <div class="border-t-2 border-blue-100 my-8" />
        <RequestOrderConfirmation class="mx-auto mt-12" />
    </PageContainer>

</template>

<style lang="scss">
.center-images img {
    display: block;
    margin: 0 auto;
}
</style>
